import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavGeneral = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M14.4 9C14.4 11.9823 11.9823 14.4 9 14.4M14.4 9C14.4 6.01766 11.9823 3.6 9 3.6M14.4 9H3.6M9 14.4C6.01766 14.4 3.6 11.9823 3.6 9M9 14.4C10.3507 12.9213 11.1187 11.0023 11.1604 9C11.1187 6.9977 10.3507 5.07871 9 3.6M9 14.4C7.64931 12.9213 6.88209 11.0023 6.84037 9C6.88209 6.9977 7.64931 5.07871 9 3.6M3.6 9C3.6 6.01766 6.01766 3.6 9 3.6M4.95 14.4C4.95 15.1456 4.34558 15.75 3.6 15.75C2.85442 15.75 2.25 15.1456 2.25 14.4C2.25 13.6544 2.85442 13.05 3.6 13.05C4.34558 13.05 4.95 13.6544 4.95 14.4ZM15.75 14.4C15.75 15.1456 15.1456 15.75 14.4 15.75C13.6544 15.75 13.05 15.1456 13.05 14.4C13.05 13.6544 13.6544 13.05 14.4 13.05C15.1456 13.05 15.75 13.6544 15.75 14.4ZM4.95 3.6C4.95 4.34558 4.34558 4.95 3.6 4.95C2.85442 4.95 2.25 4.34558 2.25 3.6C2.25 2.85442 2.85442 2.25 3.6 2.25C4.34558 2.25 4.95 2.85442 4.95 3.6ZM15.75 3.6C15.75 4.34558 15.1456 4.95 14.4 4.95C13.6544 4.95 13.05 4.34558 13.05 3.6C13.05 2.85442 13.6544 2.25 14.4 2.25C15.1456 2.25 15.75 2.85442 15.75 3.6Z"
      stroke={props.stroke || text_colorTextSecondary}
      strokeWidth="1.197"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgSidenavGeneral
